import type { PublicStory } from "../types";

// The same chronological feed drives both the opening and the archive.
// No subject-specific slots: every publication can become the opening story.
export function discoveryStories(stories: PublicStory[], limit = 5) {
  return stories.filter((story, index, items) => items.findIndex(item => item.id === story.id) === index)
    .slice().sort(comparePublicationOrder)
    .slice(0, limit);
}

export function comparePublicationOrder(a: Pick<PublicStory, "id" | "publishedAt">, b: Pick<PublicStory, "id" | "publishedAt">) {
  return Date.parse(b.publishedAt) - Date.parse(a.publishedAt) || (a.id < b.id ? 1 : a.id > b.id ? -1 : 0);
}

export function countNewStories(stories: PublicStory[], previous?: PublicStory) {
  return previous ? stories.filter(story => comparePublicationOrder(story, previous) < 0).length : stories.length;
}

export function previewChapters(content: string) {
  const headings = [...content.matchAll(/^##\s+(.+)$/gm)];
  return headings.map((heading, index) => {
    const body = content.slice(heading.index! + heading[0].length, headings[index + 1]?.index ?? content.length);
    const paragraph = body.split(/\n\s*\n/).map(text => text.trim()).find(text => text && !/^(?:#|!\[|\|)/.test(text)) || "";
    const plain = paragraph.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1").replace(/[*_`]/g, "").replace(/\n/g, " ");
    return { title: heading[1].replace(/^\d+[.)]\s*/, ""), excerpt: plain.length > 420 ? `${plain.slice(0, 420).replace(/\s+\S*$/, "")}…` : plain };
  });
}

export function swipeDirection(x: number, y: number, elapsed: number): -1 | 0 | 1 {
  if (Math.abs(x) < Math.abs(y) * 1.3 || Math.abs(x) < 18) return 0;
  if (Math.abs(x) < 48 && Math.abs(x) / Math.max(elapsed, 1) < .45) return 0;
  return x < 0 ? 1 : -1;
}
